import { css } from 'astroturf';
import React from 'react';

import Link from './link';

const styles = css`
  .featureCloud {
    display: flex;
    font-size: calc(14px + 0.25vw);
    font-weight: 500;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 1rem auto 2rem;
    padding: 0 2rem;
    line-height: 1;
    gap: 1rem 1.5rem;

    color: rgba(255, 255, 255, 0.6);

    &.light {
      color: rgba(0, 0, 0, 0.6);

      & div.highlight {
        color: #000;
      }
    }

    & a {
    white-space: nowrap;
    }
    & div {
      line-height: 1.5;
      &.highlight {
        font-size: 1.15em;
        color: #fff;
      }
    }
  }
`;

function FeatureCloud(props) {
  return (
    <div className={[styles.featureCloud, props.type ? styles[props.type] : ''].join(' ')}>
      <div className={styles.highlight}>
        <Link to="/docs/pane-management/">Unlimited Viewports</Link>
      </div>
      <div>
        <Link to="/docs/synced-interactions/">Scroll Syncing</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/synced-interactions/#mouse-interactions/">Hover Syncing</Link>
      </div>
      <div>
        <Link to="/docs/rulers-grids-and-guides/">Grid Overlays</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/console/">Unified Console</Link>
      </div>
      <div>
        <Link to="/docs/synced-interactions/#keyboard-interactions">Keyboard Syncing</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/json-and-xml-viewer/">JSON and XML Viewer</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/device-presets/">Device Presets</Link>
      </div>
      <div>
        <Link to="/docs/pane-sizes/">Freeform Resizing</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/horizontal-overflow/">Horizontal Overflow Detection</Link>
      </div>
      <div>
        <Link to="/docs/intro-to-panel/">Developer Tools</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/social-media-previews/">Pixel-perfect Social Media Previews</Link>
      </div>
      <div>
        <Link to="/docs/layouts/">5 different Layout Modes</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/emulation/">Device Emulation</Link>
      </div>
      <div>
        <Link to="/docs/live-auto-reloading/">Live Reloading</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/accessibility-panel/">Accessibility Audits</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/session-management/">Custom Sessions</Link>
      </div>
      <div>
        <Link to="/docs/outline-panel/">Page Outlines</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/snippets/">CSS and JS Editing</Link>
      </div>
      <div>
        <Link to="/docs/simulators/">Color Blindness Simulators</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/making-screenshots/#full-page-screenshots">Full Page Screenshots</Link>
      </div>
      <div>
        <Link to="/docs/image-overlay/">Visual Design Diffing</Link>
      </div>
      <div>
        <Link to="/docs/layout-debugging/">Layout debugging</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/recording/">Video Recording</Link>
      </div>
      <div>
        <Link to="/docs/meta-information/">Meta Data Overview</Link>
      </div>
      <div>
        <Link to="/portal/">Synced external browsers</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/breakpoints/">CSS Breakpoint Detection</Link>
      </div>
      <div>
        <Link to="/docs/making-screenshots/#overview-screenshot-of-all-panes">Overview Screenshots</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/elements-panel/">Unified Element Inspector</Link>
      </div>
      <div>
        <Link to="/docs/emulation/#touch-emulation">Touch Emulation</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/form-autofill/">Automated Form Testing</Link>
      </div>
      <div>
        <Link to="/docs/making-screenshots/#screenshot-editing">Screenshot Editor</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/web-vitals/">Web Vitals Inspector</Link>
      </div>
      <div>
        <Link to="/docs/color-picker/">Color Picker</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/browser-extensions/">Browser Extensions</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/outline-panel/#broken-link-checking">Broken Link Checking</Link>
      </div>
      <div>
        <Link to="/docs/link/">Share Links</Link>
      </div>
      <div>
        <Link to="/docs/emulation/#custom-http-headers">Custom Headers</Link>
      </div>
      <div className={styles.highlight}>
        <Link to="/docs/dark-and-light-mode/">Dark Mode</Link>
      </div>
      <div>
        <Link to="/docs/workspaces/">Workspaces</Link>
      </div>
      <div className={styles.highlight}>
        &hellip;and more <Link to="/docs/changelog/">added monthly</Link>!
      </div>
    </div>
  );
}

export default FeatureCloud;
